import { render } from "./HospitalPharmacyDispensingCabinet.vue?vue&type=template&id=dc6adc6e"
import script from "./HospitalPharmacyDispensingCabinet.vue?vue&type=script&lang=js"
export * from "./HospitalPharmacyDispensingCabinet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__